import * as React from "react";
import { forwardRef } from "react";
const SvgList = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 30, height: 25, fill: "currentColor", viewBox: "0 0 30 25", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.333.629h20v4h-20zm-9 0h4.3v4h-4.3zm9 20h20v4h-20zm-9 0h4.3v4h-4.3zm9-10h20v4h-20zm-9 0h4.3v4h-4.3z" }));
const ForwardRef = forwardRef(SvgList);
export default ForwardRef;
